import {Injectable} from '@angular/core';
import {Observable, of, ReplaySubject} from 'rxjs';
import {map, share, switchMap, tap} from 'rxjs/operators';
import {TokenService} from './token.service';
import {User} from './interface';
import {UserApiService} from './user-api.service';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private user$ = new ReplaySubject<User>();

  constructor(private loginService: UserApiService, private token: TokenService) {
    this.token
      .changed()
      .pipe(
        switchMap(() => {
          if (this.check()) {
            return this.loginService.basicUserInfo();
          }

          return of(null);
        })
      )
      .subscribe(user => {
        if (user !== null) {
          Sentry.setUser(user);
          this.user$.next(Object.assign({}, user));
        }
      });
  }

  check() {
    return this.token.valid();
  }

  login(email: string, password: string) {
    return this.loginService.login(email, password).pipe(
      map(response => {
        console.log(response);
        return response.data;
      }),
      tap(token => this.token.set(token)),
      map(() => this.check())
    );
  }

  logout() {
    return this.loginService.logout().pipe(
      tap(() => this.token.clear()),
      map(() => !this.check())
    );
  }

  updatePassword(userId: string, newPassword: string) {
    return this.loginService.updatePassword(userId, newPassword);
  }

  user(): Observable<User> {
    return this.user$.pipe(share());
  }
}
